import {t} from "@lingui/core/macro";

import type {Module} from "./types.ts";

/**
 * Takes a "TopicProgress" module and applies tranformations as necessary.
 */
// NOTE(tonydinh): If we want to properly TypeScript type this in the future, we'll
// need to add a TypeScript type for the data that comes back from GraphQL as well as
// a TypeScript type for the transformed module.
export const transformUnitProgressModule = (
    unitProgressModule: Module,
): Module => {
    const {quizzes, unitTest, ...otherProps} = unitProgressModule;
    const transformedModule = {...otherProps} as const;

    // Add translated titles to Quizzes
    if (quizzes) {
        // @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: any; readonly kind: string; }' only permits reading. | TS2345 - Argument of type '(result: Record<string, any>, key: string) => Record<string, any>' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: string | number | symbol, currentIndex: number, array: (string | number | symbol)[]) => Record<string, any>'.
        transformedModule.quizzes = Object.keys(quizzes || {}).reduce<
            Record<string, any>
        >((result: Record<string, any>, key: string) => {
            const quiz = quizzes[key];
            result[key] = {
                ...quiz,
                title:
                    quiz.quizIndex && quiz.quizIndex > 0
                        ? t`Quiz ${quiz.quizIndex}`
                        : t`Quiz`,
            };
            return result;
        }, {});
    }

    // Add translated title to Unit Test
    if (unitTest) {
        // @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: any; readonly kind: string; }' only permits reading.
        transformedModule.unitTest = {
            ...unitTest,
            title: t`Unit test`,
        };
    }

    return transformedModule;
};
